import type { FunctionComponent, PropsWithChildren } from 'react';

import { useGameStateSlice } from '../../store/slices/game/selectors';
import { useModifiers } from '../../styles/hooks/useModifiers';

import styles from './HideDialogs.module.css';

export interface HideDialogsConnectedProps extends PropsWithChildren {
  /** Attribute that allow to ignore Desktop from hiding */
  ignoreDesktop?: boolean;
  /** Attribute that allow to ignore Mobile from hiding */
  ignoreMobile?: boolean;
}

export const HideDialogsConnected: FunctionComponent<HideDialogsConnectedProps> = ({
  children,
  ignoreDesktop,
  ignoreMobile,
}) => {
  const hideUI = useGameStateSlice.hideUI();

  const hideDialogs = useModifiers(styles, 'hideDialogs', {
    hidden: hideUI,
    ignoreDesktop,
    ignoreMobile,
  });

  return <div className={hideDialogs}>{children}</div>;
};
